import Cookies from 'js-cookie'

const COOKIE_KEY = 'layoutTheme'
const COOKIE_DAYS = 365

export function getLayoutTheme () {
  return Cookies.get(COOKIE_KEY) === 'dark' ? 'dark' : 'light'
}

/**
 * 同步 `html.theme-dark`，供全域淺／深色版面與 Element 覆寫使用。
 * @param {'light'|'dark'} theme
 */
export function applyLayoutThemeClass (theme) {
  const isDark = theme === 'dark'
  if (typeof document !== 'undefined') {
    document.documentElement.classList.toggle('theme-dark', isDark)
  }
}

export function persistLayoutTheme (theme) {
  const t = theme === 'dark' ? 'dark' : 'light'
  Cookies.set(COOKIE_KEY, t, { expires: COOKIE_DAYS })
  applyLayoutThemeClass(t)
  return t
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/layoutTheme.js